import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = new Sortable(this.element, {
      animation: 150,
      ghostClass: "opacity-50",
      filter: "button",
      preventOnFilter: false,
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onEnd() {
    this.updatePositions()
  }

  updatePositions() {
    const items = this.element.querySelectorAll("[data-sortable-item]:not(.hidden)")
    items.forEach((item, index) => {
      const positionInput = item.querySelector("[data-position-field]")
      if (positionInput) {
        positionInput.value = index
      }
    })
  }
}
